// extracted by mini-css-extract-plugin
export var shoppingBagIcon = "icons-module--shoppingBagIcon--r6AR+";